module.exports = __webpack_public_path__ + "static/media/33_plantilla_rec_combo_simple_cp_gaseosas_pet_500_cssa_y_csso.75d76956.png";